export default __webpack_public_path__ + "static/media/concierge-care-logo.2fe6e1ba.png";